module.exports = __webpack_public_path__ + "static/media/MentorCatriona.3db4ca01.jpeg";